import { fetchAuthSession } from 'aws-amplify/auth';
import { Api, buildQueryString } from '@/common/utils/index';

export const getResellers = (params) =>
  Api.request({
    url: `/resellers${buildQueryString(params)}`,
  });

export const getReseller = (id) =>
  Api.request({
    url: `/resellers/${id}`,
  });

export const createReseller = (payload) =>
  Api.request({
    url: '/resellers',
    method: 'post',
    payload,
  });

export const updateReseller = (id, payload) =>
  Api.request({
    url: `/resellers/${id}`,
    method: 'put',
    payload,
  });

export const deleteReseller = (id) =>
  Api.request({
    url: `/resellers/${id}`,
    method: 'delete',
  });

export const exportResellersCsv = async (params) => {
  const token = (await fetchAuthSession()).tokens?.accessToken?.toString();

  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/resellers/export/csv${buildQueryString(params)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Export resellers error');
  }

  return response.blob();
};
